export const ADD_PRODUCT_CART = "cart/add_product";
export const REPLACE_PRODUCT_CART = "cart/replace_product";
export const REMOVE_PRODUCT_CART = "cart/remove_product";
export const RESET_CART = "cart/reset_cart";
